import {Form, InputNumber, Modal,  App,  Row, Col, DatePicker, Space   } from 'antd'
import React, { useEffect,useState } from 'react'
import classes from './cost.module.css'
import { useDingdanzhichuUpdateSaveMutation, useDingdanzhichuUpdateQuery, useFKtijiaoMutation } from '../../store/DianShangYeWuApi';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';
import ClientBankSelect from '../../system/client/ClientBankSelect';
import ReportDeptSelect from '../../system/dept/DeptSelect';
import UploadPic from '../../cpn/UploadPic';
import dayjs from 'dayjs';
import Icon from '../../cpn/Icon';    
import DocumentRule from '../../cpn/DocumentRule';  
import Asterisk from '../../cpn/Asterisk';
import CostNodeEdit from './CostNodeEdit';
import CostDel from './CostDel';    
import ArapTypeSelect from '../../cpn/ArapTypeSelect';  
import StateTag from '../../cpn/StateTag';
import CostWithdraw from './CostWithdraw';
import AccountCheck from '../../system/account/AccountCheck';
import { ASSETS_APPLICATION_BASE } from '../../config/api';
function CostEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'ddzc_price':'',   
        'ddzc_uid':'',
        'ddzc_uname':'',
        'ddzc_content':'',
        'ddzc_bzd_id':'',
        'ddzc_qy_id':'',
        'ddzc_qy_name':'',
        'ddzc_kh_id':'',
        'ddzc_kh_name':'',
        'ddzc_type_id':'',
        'ddzc_type_name':'',
        'ddzc_amount':'',
        'ddzc_bzd_xuhao':'',
        'ddzc_bzd_name':'',
        'ddzc_date':'',
        'ddzc_bzd_date_end':'',
        'ddzc_num':'',
        'ddzc_name':'',
        'ddzc_bzd_date':'',
        'ddzc_khyhzh_id':'',
        'ddzc_khyhzh_name':'',
        'ddzc_image_name':'',
        'ddzc_image_file':'',
        'ddzc_bm_id':'',
        'ddzc_bm_name':'',
        'ddzc_state':'',
        'ddzc_ctime':'',
        'ddzc_state_time':'',
        'ddzc_zflx':'',
        'ddzc_qyyhzh_id':'',
        'ddzc_qyyhzh_name':'',
        'ddzc_qyyhzh_date':'',
    })
    const {data, isSuccess} = useDingdanzhichuUpdateQuery({ddzc_id:props.ddzc_id},{skip:!open});
    const [form] = Form.useForm();
    const [updateSave] = useDingdanzhichuUpdateSaveMutation();  
    const [defaultFileList, setDefaultFileList] = useState([]);
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'ddzc_price': data.Result.ddzc_price,   
                'ddzc_uid': data.Result.ddzc_uid,
                'ddzc_uname': data.Result.ddzc_uname,
                'ddzc_content': data.Result.ddzc_content,
                'ddzc_bzd_id': data.Result.ddzc_bzd_id,
                'ddzc_qy_id': data.Result.ddzc_qy_id,
                'ddzc_qy_name': data.Result.ddzc_qy_name,
                'ddzc_kh_id': data.Result.ddzc_kh_id,
                'ddzc_kh_name': data.Result.ddzc_kh_name,
                'ddzc_type_id': data.Result.ddzc_type_id,
                'ddzc_type_name': data.Result.ddzc_type_name,
                'ddzc_amount': data.Result.ddzc_amount,
                'ddzc_bzd_xuhao': data.Result.ddzc_bzd_xuhao,
                'ddzc_bzd_name': data.Result.ddzc_bzd_name,
                'ddzc_date': data.Result.ddzc_date,
                'ddzc_bzd_date_end': data.Result.ddzc_bzd_date_end,
                'ddzc_num': data.Result.ddzc_num,
                'ddzc_name': data.Result.ddzc_name,
                'ddzc_bzd_date': data.Result.ddzc_bzd_date,
                'ddzc_khyhzh_id': data.Result.ddzc_khyhzh_id,
                'ddzc_khyhzh_name': data.Result.ddzc_khyhzh_name,
                'ddzc_image_name': data.Result.ddzc_image_name,
                'ddzc_image_file': data.Result.ddzc_image_file,
                'ddzc_bm_id': data.Result.ddzc_bm_id,
                'ddzc_bm_name': data.Result.ddzc_bm_name,
                'ddzc_state': data.Result.ddzc_state,
                'ddzc_ctime': data.Result.ddzc_ctime,
                'ddzc_state_time': data.Result.ddzc_state_time,
                'ddzc_zflx': data.Result.ddzc_zflx,
                'ddzc_qyyhzh_id': data.Result.ddzc_qyyhzh_id,
                'ddzc_qyyhzh_name': data.Result.ddzc_qyyhzh_name,
                'ddzc_qyyhzh_date': data.Result.ddzc_qyyhzh_date,
            });
            setDefaultFileList(Array.isArray(data.Result.ddzc_image_name) ? data.Result.ddzc_image_name.filter(Boolean) : []);
            const imageNameArray = Array.isArray(data.Result.ddzc_image_name) 
            ? data.Result.ddzc_image_name.filter(Boolean)
            : (data.Result.ddzc_image_name ? [data.Result.ddzc_image_name] : []);
            const imageFileArray = Array.isArray(data.Result.ddzc_image_file)
                ? data.Result.ddzc_image_file.filter(Boolean)
                : (data.Result.ddzc_image_file ? [data.Result.ddzc_image_file] : []);

            const fileListForForm = imageNameArray.map((serverFileName, i) => {
                // 确保 URL 是完整路径
                // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                let fullUrl = serverFileName;
                if (serverFileName.startsWith('http://')) {
                    // 完整 URL，直接使用
                    fullUrl = serverFileName;
                } else if (serverFileName.startsWith('/')) {
                    // 已经是相对路径，检查是否需要添加 /api 前缀
                    if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                        fullUrl = `/api${serverFileName}`;
                    } else {
                        fullUrl = serverFileName;
                    }
                } else {
                    // 只是文件名，使用 /api/assets/images/application/ 路径
                    fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                }
                
                // 获取显示名称
                const displayName = imageFileArray[i] || undefined;
                
                return {
                    uid: `file-${i}-${serverFileName}`,
                    name: displayName || serverFileName || `文件${i + 1}`,
                    status: 'done',
                    url: fullUrl,
                    response: {
                        Result: serverFileName // 保存服务器文件名用于提交
                    }
                };
            });       
            form.setFieldsValue({
                    'ddzc_price': data.Result.ddzc_price,  
                    'ddzc_uid': data.Result.ddzc_uid,
                    'ddzc_uname': data.Result.ddzc_uname,
                    'ddzc_content': data.Result.ddzc_content,
                    'ddzc_bzd_id': data.Result.ddzc_bzd_id,
                    'ddzc_bzd_name': data.Result.ddzc_bzd_name,
                    'ddzc_kh_id': data.Result.ddzc_kh_id,
                    'ddzc_kh_name': data.Result.ddzc_kh_name,
                    'ddzc_name': data.Result.ddzc_name,
                    'ddzc_type_name': data.Result.ddzc_type_name,
                    'ddzc_num': data.Result.ddzc_num,
                    'ddzc_bm_name': data.Result.ddzc_bm_name,
                    'ddzc_date': dayjs(data.Result.ddzc_date),
                    'ddzc_khyhzh_name': data.Result.ddzc_khyhzh_name,
                    'ddzc_amount': data.Result.ddzc_amount,
                    'ddzc_image_name': imageNameArray,
                    'ddzc_image_file': fileListForForm,
                    'ddzc_zflx': data.Result.ddzc_zflx,
            })

        }
        
        
        
        
    }, [data, isSuccess,form])    

   
    //提交付款单
    const [tijiao] = useFKtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.ddzc_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid green',borderLeft:'3px solid green'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'green',borderTop:'3px solid green'}}>付款单</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid green',borderRight:'3px solid green'}}></Col>
                        {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid green',color:'green'}}>团队名称</Col>
                        <Col span={6}  className={classes.col_top_input} style={props.ddzc_bzd_name ? {} : {padding: '15px'}}>
                            {info.ddzc_bzd_name} 
                        </Col>  
                        <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {info.ddzc_type_name}
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid green'}}>
                            {info.ddzc_num}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 日期</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           <Form.Item name='ddzc_date' noStyle>
                               <DatePicker 
                                   placeholder='请选择日期' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, ddzc_date: value }))
                                   }}
                                   style={{ width: '100%' }}
                               />
                           </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddzc_amount' noStyle>
                               <InputNumber 
                                   placeholder='请输入金额' 
                                   onChange={(value) => {
                                       setInfo(prevState => ({ ...prevState, ddzc_amount: value }))
                                   }}
                                   style={{ width: '100%' }}
                                   min={0.01}
                               />
                           </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid green'}}>
                           <ReportDeptSelect
                               yh_id={props.yh_id}
                               wrapperCol={{span:24}}
                               placeholder='请选择部门'
                               qy_id={props.qy_id}
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, ddzc_bm_id: e, ddzc_bm_name: f }))
                               }}
                               name="ddzc_bm_name"
                               defaultId={info.ddzc_bm_id}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                           />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 付款客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='ddzc_kh_id'
                                placeholder='请选择借款客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, ddzc_kh_id: value, ddzc_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                defaultId={info.ddzc_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                        <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid green'}}>
                            <ClientBankSelect
                               name='ddzc_khyhzh_name'
                               placeholder='请选择借款客户银行'
                               onChange={(value,label) => {
                                   setInfo(prevState => ({ ...prevState, ddzc_khyhzh_id: value, ddzc_khyhzh_name: label }))
                               }}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                               wrapperCol={{span:24}}
                               qy_id={props.qy_id}
                               yh_id={props.yh_id}
                               defaultId={info.ddzc_khyhzh_id}
                               kh_id={info.ddzc_kh_id}
                           />
                        </Col>
                       {/* 第四行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 往来类型</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <ArapTypeSelect 
                                documentType='cost' 
                                onChange={(value) => {
                                    setInfo(prevState => ({ ...prevState, ddzc_zflx: value }))
                                }}
                                name='ddzc_zflx'
                                required={true}
                                style={{marginBottom: 0}}
                                wrapperCol={{span:24}}
                            />
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>备注</Col>
                       <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='ddzc_content' noStyle>
                               <OCRTextArea
                                   value={info.ddzc_content}
                                   onChange={(e) => {
                                       setInfo(prevState => ({ ...prevState, ddzc_content: e.target.value }))
                                   }}
                                   language="chi_sim"
                               />
                           </Form.Item>
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                       <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid green'}}>
                            {info.ddzc_qyyhzh_date} <AccountCheck qyyhzh_id={info.ddzc_qyyhzh_id} name={info.ddzc_qyyhzh_name} />
                       </Col>                                   
                       {/* 第五行       */}
                       <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}>编号/状态</Col>
                       <Col span={6}  className={classes.col_middle_input}>               
                           {props.ddzc_id}&emsp;<StateTag state={props.ddzc_state} />
                       </Col>                                   
                       <Col span={2} className={classes.col_middle_label}>附件</Col>
                       <Col span={14}  className={classes.col_bottom_input} style={{borderRight:'3px solid green'}}>
                           <UploadPic
                               name='ddzc_image_file'
                               onChange={(e,f) => {
                                   setInfo(prevState => ({ ...prevState, ddzc_image_file: e, ddzc_image_name: f }))
                               }}
                               maxCount={5}
                               style={{ width: '100%' }}
                               formStyle={{marginBottom: 0,width: '100%'}}
                               defaultFileList={defaultFileList}
                           />
                       </Col>            
                        {/* 第六行 */}
                        <Col span={24} className={classes.bottom_row}>
                            <CostNodeEdit 
                                qy_id={props.qy_id} 
                                user_id={props.yh_id} 
                                yh_name={props.yh_name} 
                                ddzc_id={props.ddzc_id} 
                                ddzc_state={props.ddzc_state}
                                ddzc_ctime={info.ddzc_ctime}
                                ddzc_uname={info.ddzc_uname}
                                ddzc_state_time={props.ddzc_state_time}
                            />
                        </Col>
                    </Row> 
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        if(info.ddzc_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }                                        
                                        if(info.ddzc_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.ddzc_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.ddzc_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }
                                        if(info.ddzc_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        updateSave({
                                            'ddzc_id': props.ddzc_id,
                                            'ddzc_price': info.ddzc_price,
                                            'ddzc_uid': props.yh_id,
                                            'ddzc_uname': props.yh_name,
                                            'ddzc_content': info.ddzc_content,
                                            'ddzc_bzd_id': info.ddzc_bzd_id,
                                            'ddzc_qy_id': props.qy_id,
                                            'ddzc_qy_name': props.qy_name,
                                            'ddzc_kh_id': info.ddzc_kh_id,
                                            'ddzc_kh_name': info.ddzc_kh_name,
                                            'ddzc_type_id': info.ddzc_type_id,
                                            'ddzc_type_name': info.ddzc_type_name,
                                            'ddzc_amount': info.ddzc_amount,
                                            'ddzc_bzd_xuhao': '',
                                            'ddzc_bzd_name': info.ddzc_bzd_name,
                                            'ddzc_date': info.ddzc_date,
                                            'ddzc_bzd_date_end': info.ddzc_bzd_date_end?info.ddzc_bzd_date_end:'',
                                            'ddzc_num': info.ddzc_num, 
                                            'ddzc_name': '',
                                            'ddzc_bzd_date': info.ddzc_bzd_date?info.ddzc_bzd_date:'',
                                            'ddzc_khyhzh_id': info.ddzc_khyhzh_id,
                                            'ddzc_khyhzh_name': info.ddzc_khyhzh_name,
                                            'ddzc_image_name': info.ddzc_image_name?info.ddzc_image_name:'',
                                            'ddzc_image_file': info.ddzc_image_file?info.ddzc_image_file:'',
                                            'ddzc_bm_id': info.ddzc_bm_id,
                                            'ddzc_bm_name': info.ddzc_bm_name,
                                            'ddzc_state': '1',
                                            'ddzc_zflx': info.ddzc_zflx,    
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                                {props.ddzc_state === '2' && <CostWithdraw ddzc_id={props.ddzc_id} />}
                                {(props.ddzc_state === '1' || props.ddzc_state === '4') && <CostDel ddzc_id={props.ddzc_id} />}
                                <Icon 
                                    type='submit' 
                                    onClick={() => {
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                    
                                        if(info.ddzc_amount === ''){
                                            message.error('请输入金额');
                                            return;
                                        }

                                        if(info.ddzc_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        }
                                        if(info.ddzc_khyhzh_id === ''){
                                            message.error('请选择银行账户');
                                            return;
                                        }

                                        if(info.ddzc_bm_id === ''){
                                            message.error('请选择部门');
                                            return;
                                        }
                                        if(info.ddzc_date === ''){
                                            message.error('请选择日期');
                                            return;
                                        }
                                        if(info.ddzc_zflx === ''){
                                            message.error('请选择往来类型');
                                            return;
                                        }
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        tijiao({
                                            'ddzc_id': props.ddzc_id,
                                            'ddzc_uid': props.yh_id,  
                                            'ddzc_uname': props.yh_name,
                                            'qy_id': props.qy_id,
                                            'qy_name': props.qy_name,
                                            'ddzc_name': '无',
                                            'ddzc_date': info.ddzc_date,
                                            'ddzc_kh_id': info.ddzc_kh_id, 
                                            'ddzc_kh_name': info.ddzc_kh_name,
                                            'ddzc_sp_ddzc_amount': info.ddzc_amount,
                                            'ddzc_sp_ddzc_content': info.ddzc_content,
                                            'ddzc_sp_dsbzd_id': props.ddzc_bzd_id,
                                            'ddzc_sp_dsbzd_name': props.ddzc_bzd_name,
                                            'ddzc_bm_id': info.ddzc_bm_id,
                                            'ddzc_bm_name': info.ddzc_bm_name,
                                            'ddzc_khyhzh_id': info.ddzc_khyhzh_id,
                                            'ddzc_khyhzh_name': info.ddzc_khyhzh_name,
                                            'ddzc_image_name': info.ddzc_image_name?info.ddzc_image_name:'',
                                            'ddzc_image_file': info.ddzc_image_file?info.ddzc_image_file:'',
                                            'ddzc_zflx': info.ddzc_zflx,
                                            'ddzc_spjd_bm_id': info.ddzc_bm_id,
                                            'ddzc_spjd_zflx': info.ddzc_zflx,
                                            'ddzc_spjd_amount': info.ddzc_amount,
                                            'ddzc_spjd_user_id': props.yh_id,
                                        }).then(res => {
                                            if(res.data.Status === 'success') {
                                                message.success('付款单提交成功！')
                                            } else {
                                                message.error('付款单提交失败！'+res.data.Message)
                                            }
                                        })
                                        .catch((err) => {
                                            message.error('付款单提交失败！'+(err.response?.data?.Message||''))
                                        })
                                        .finally(() => {
                                            setIsSubmitting(false);
                                        })
                                    }} 
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                />  
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default CostEdit